import { extractApiErrorMessage } from '@/shared';
import { Alert, AlertDescription, AlertTitle } from '@/shared/ui/shadcn/alert';
import { Button } from '@/shared/ui/shadcn/button';

export interface WorklistLoadingProps {
  readonly label?: string;
}

export function WorklistLoading({ label = 'Loading worklist…' }: WorklistLoadingProps) {
  return (
    <div role="status" aria-live="polite" className="text-muted-foreground text-sm">
      {label}
    </div>
  );
}

export interface WorklistEmptyProps {
  readonly label: string;
  readonly hint?: string;
}

export function WorklistEmpty({ label, hint }: WorklistEmptyProps) {
  return (
    <div className="text-muted-foreground flex flex-col gap-1 text-sm">
      <span>{label}</span>
      {hint ? <span className="text-xs opacity-80">{hint}</span> : null}
    </div>
  );
}

export interface WorklistErrorProps {
  readonly title: string;
  readonly error: unknown;
  readonly onRetry?: () => void;
}

export function WorklistError({ title, error, onRetry }: WorklistErrorProps) {
  const message = extractApiErrorMessage(error, 'Could not load worklist.');
  return (
    <Alert variant="destructive">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="flex flex-col gap-2">
        <span>{message}</span>
        {onRetry ? (
          <Button type="button" variant="outline" size="sm" className="w-fit" onClick={onRetry}>
            Retry
          </Button>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
